import React from 'react'

import { CTATheme, mq, useMediaQuery } from 'marketing-site/src/library/utils'
import useModalOpenState from 'marketing-site/lib/useModalOpenState'
import Modal, { ModalSize } from 'marketing-site/src/components/common/Modal'
import { CTAButton } from 'marketing-site/src/library/elements/CTAButton'
import PlayButton from './components/PlayButton'
import { IProps } from './index'

export const ImageWithModalVideo: React.FC<IProps> = ({ image, modalVideo }) => {
  const [modalOpen, openModal, closeModal] = useModalOpenState()

  const playButtonSize = useMediaQuery(`(${mq.mobile})`) ? 'sm' : 'md'

  return (
    <>
      <div className="image-with-modal-video" data-testid="image-with-modal-video">
        <CTAButton
          text={`placeholder`}
          onClick={() => openModal()}
          bgColor={CTATheme.BlueFill}
          arrow={false}
        >
          <div className="image-with-modal-video__cta-button-content">
            {image}
            <PlayButton size={playButtonSize} />
          </div>
        </CTAButton>
        <Modal isOpen={modalOpen} onRequestClose={closeModal} size={ModalSize.Medium}>
          {modalVideo}
        </Modal>
      </div>

      <style jsx>
        {`
          .image-with-modal-video {
            display: inline-block;
            vertical-align: middle; // Removes blank space below
            position: relative;

            & :global(.cta-button) {
              display: block;
              width: 100%;
              position: relative;
              cursor: pointer;

              &:focus {
                outline: initial;
              }
            }

            & :global(img) {
              width: 100%;
            }

            & :global(.play-button) {
              display: block;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        `}
      </style>
    </>
  )
}
